import React, { useState } from 'react';
import styled from 'styled-components';
import { SafelistSummaryItem } from './SafelistSummaryItem';
const StyledSafelistLibraryListContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const StyledNoLibrariesMessageContainer = styled.div `
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledNoLibrariesMessage = styled.p ``;
const StyledSafelistSummaryItem = styled(SafelistSummaryItem) `
  &:not(:last-child) {
    margin-bottom: 0.67rem;
  }
`;
const initSafelistSummaryMap = (safelistSummaries, selectedSummaryGuids) => safelistSummaries.reduce((safelistSummaryMap, safelistSummary) => {
    const isSelected = selectedSummaryGuids.indexOf(safelistSummary.guid) > -1;
    safelistSummaryMap[safelistSummary.guid] = {
        isSelected,
        safelistSummary,
    };
    return safelistSummaryMap;
}, {});
const SafelistLibraryList = ({ className, itemClassName, selectedItemClassName, itemContextMenuClassName, itemCheckboxColor, itemCheckboxSelectedColor, safelistSummaries, selectedSummaryGuids = [], onEditSummaryItem, onDeleteSummaryItem, onSelect, showContextMenu = false, }) => {
    const [selectedLibraries, setSelectedLibraries] = useState(initSafelistSummaryMap(safelistSummaries, selectedSummaryGuids));
    const handleLibrarySelection = (safelistSummary) => {
        var _a;
        const updatedSelectedLibraries = Object.assign({}, selectedLibraries, {
            [safelistSummary.guid]: {
                isSelected: !((_a = selectedLibraries[safelistSummary.guid]) === null || _a === void 0 ? void 0 : _a.isSelected),
                safelistSummary,
            },
        });
        setSelectedLibraries(updatedSelectedLibraries);
        if (onSelect) {
            const selectedLibraryGuids = [];
            Object.values(updatedSelectedLibraries).forEach((selectedLibrary) => {
                if (selectedLibrary.isSelected) {
                    selectedLibraryGuids.push(selectedLibrary.safelistSummary.guid);
                }
            });
            onSelect(selectedLibraryGuids);
        }
    };
    return (React.createElement(StyledSafelistLibraryListContainer, { className: className }, safelistSummaries.length > 0
        ? safelistSummaries.map((safelistSummary) => {
            var _a;
            return (React.createElement(StyledSafelistSummaryItem, { key: safelistSummary.guid, className: itemClassName, selectedClassName: selectedItemClassName, contextMenuClassName: itemContextMenuClassName, checkboxColor: itemCheckboxColor, checkboxSelectedColor: itemCheckboxSelectedColor, onSelectCallback: handleLibrarySelection, onEdit: onEditSummaryItem, onDelete: onDeleteSummaryItem, summaryItem: safelistSummary, isSelected: (_a = selectedLibraries[safelistSummary.guid]) === null || _a === void 0 ? void 0 : _a.isSelected, showContextMenu: showContextMenu }));
        })
        : React.createElement(StyledNoLibrariesMessageContainer, null,
            React.createElement(StyledNoLibrariesMessage, null, "There are no safelist libraries."))));
};
export { SafelistLibraryList };
